"use strict";

import { Collection } from "Collection";
import { AppObjectsModel } from 'Models/AppObjectsModel';
import { Objects } from "Constants/objects";
export var AppObjectsCollection = Collection.extend({
  model: AppObjectsModel,
  object: Objects.SysAppObjects
});